/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */
import { FC } from 'react';

import { IPageSubscriberMobileTranslation } from '../../../../../modules/internationalization/types';
import { ILabelColor } from '../../../constants/labelColor';
import {
    TableTextDefaultValueStyled,
    TableTextTooltipStyled,
} from '../styled/TableBlockStyled';
import { LabelCellStyled, TableLabelBlockStyled } from '../styled/TableLabelBlockStyled';

/**
 * @description Label props
 * @interface ILabel
 * @property {number} id - label id
 * @property {string} color - label color
 * @property {string} name - label name
 */
export interface ILabel {
    color: string;
    id: number;
    name: string;
}

/**
 * @description Table LabelBlock props
 * @interface ITableLabelBlockProps
 * @property {IPageSubscriberMobileTranslation['table']} translation - locale
 * @property {ILabel[]} value - labels list
 */
export interface ITableLabelBlockProps {
    defaultValue?: string;
    translation: IPageSubscriberMobileTranslation['table'];
    value: ILabel[];
}


const TableLabelBlock: FC<ITableLabelBlockProps> = props => (
    <>
        {
            props.value.length
            ?
            props.value.map((label: ILabel) => (
                <TableLabelBlockStyled
                    key={label.id}
                >
                    <LabelCellStyled
                        color={('color' + label.color) as ILabelColor}>
                    </LabelCellStyled>
                    <TableTextTooltipStyled>
                        {label.name}
                    </TableTextTooltipStyled>
                </TableLabelBlockStyled>
            ))
            :
            <TableTextDefaultValueStyled>
                {props.defaultValue}
            </TableTextDefaultValueStyled>
        }
    </>
);

export default TableLabelBlock;
